module.exports = __webpack_public_path__ + "img/hadiah-100rb.4ecc9186.png";